import React from 'react';

/**
 * Icono Material Symbols Rounded (el iconset del rediseño).
 * Uso: <Sym name="download" size={22} color="#6FA0FF" />
 * `fill`, `wght`, `grade`, `opsz` mapean a las font-variation-settings del set.
 */
const Sym = ({ name, size = 24, color, fill = 0, wght = 400, grade = 0, style = {}, className = '', ...rest }) => (
  <span
    className={`msym ${className}`}
    aria-hidden="true"
    translate="no"
    style={{
      // fontFamily inline para no depender de la cascada de la clase .msym
      fontFamily: "'Material Symbols Rounded'",
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 1,
      letterSpacing: 'normal',
      textTransform: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
      direction: 'ltr',
      fontFeatureSettings: "'liga'",
      WebkitFontFeatureSettings: "'liga'",
      WebkitFontSmoothing: 'antialiased',
      display: 'inline-block',
      fontSize: size,
      color,
      fontVariationSettings: `'opsz' ${size}, 'wght' ${wght}, 'FILL' ${fill}, 'GRAD' ${grade}`,
      ...style,
    }}
    {...rest}
  >
    {name}
  </span>
);

export default Sym;
